/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Copy_Event_Text_DescriptionInputs */



/**
* | output |
* | --- |
* | "Copy dialogue from overlapping events in one group into another" |
*
* @param {Copy_Event_Text_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const copy_event_text_description = /** @type {((inputs?: Copy_Event_Text_DescriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Copy_Event_Text_DescriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Copier le dialogue des événements qui se chevauchent d'un groupe vers un autre")
	if (locale === "de") return /** @type {LocalizedString} */ ("Dialog aus überlappenden Ereignissen einer Gruppe in eine andere kopieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Copia il dialogo dagli eventi sovrapposti di un gruppo in un altro")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Копировать текст из перекрывающихся событий одной группы в другую")
	if (locale === "es") return /** @type {LocalizedString} */ ("Copiar diálogo de eventos superpuestos de un grupo a otro")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("将一个组中重叠事件的文本复制到另一个组")
	if (locale === "ja") return /** @type {LocalizedString} */ ("重複するイベントのテキストを別のグループにコピーします")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एक समूह में ओवरलैप होने वाले इवेंट्स से दूसरे समूह में संवाद कॉपी करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Copiar diálogo de eventos sobrepostos de um grupo para outro")
	return /** @type {LocalizedString} */ ("Copy dialogue from overlapping events in one group into another")
});